/* ============================================================
   TitleFinder AU — Conversion Boosters
   1. Social proof notifications
   2. Sticky mobile CTA bar (product pages)
   3. Live activity counter
   4. Urgency badge on products
   ============================================================ */
(function() {
  'use strict';

  // ============================================================
  // 1. SOCIAL PROOF NOTIFICATIONS
  // "Someone from [city] just ordered a [product]"
  // ============================================================
  var cities = [
    'Brisbane', 'Gold Coast', 'Sunshine Coast', 'Townsville', 'Cairns',
    'Toowoomba', 'Rockhampton', 'Mackay', 'Bundaberg', 'Hervey Bay',
    'Gladstone', 'Maryborough', 'Mount Isa', 'Ipswich', 'Logan',
    'Redlands', 'Moreton Bay', 'Noosa', 'Caloundra', 'Nambour'
  ];

  var products = [
    { name: 'Current Title', price: '$33.90' },
    { name: 'Current Title', price: '$33.90' },
    { name: 'Current Title', price: '$33.90' },
    { name: 'Historical Title', price: '$33.90' },
    { name: 'Guaranteed Search', price: '$42.90' },
    { name: 'Survey Plan', price: '$29.90' },
    { name: 'Dealing Instrument', price: '$29.90' }
  ];

  var timeAgo = ['2 minutes ago', '5 minutes ago', '8 minutes ago', '12 minutes ago', '15 minutes ago', '23 minutes ago', '31 minutes ago', '45 minutes ago', '1 hour ago'];

  function showSocialProof() {
    // Don't show if user is in checkout or cart
    if (window.location.pathname.includes('/checkout') || window.location.pathname.includes('/cart')) return;
    // Don't show more than 3 per session
    var count = parseInt(sessionStorage.getItem('tf_sp_count') || '0');
    if (count >= 3) return;

    var city = cities[Math.floor(Math.random() * cities.length)];
    var product = products[Math.floor(Math.random() * products.length)];
    var time = timeAgo[Math.floor(Math.random() * timeAgo.length)];

    var el = document.createElement('div');
    el.className = 'tf-social-proof';
    el.innerHTML = [
      '<div class="tf-sp-icon">🛒</div>',
      '<div class="tf-sp-text">',
      '  <strong>Someone from ' + city + '</strong>',
      '  <span>ordered a ' + product.name + ' — ' + time + '</span>',
      '</div>',
      '<button class="tf-sp-close" aria-label="Close">&times;</button>'
    ].join('');

    document.body.appendChild(el);

    requestAnimationFrame(function() {
      el.classList.add('tf-sp-visible');
    });

    el.querySelector('.tf-sp-close').onclick = function() {
      el.classList.remove('tf-sp-visible');
      setTimeout(function() { el.remove(); }, 300);
    };

    // Auto-hide after 5 seconds
    setTimeout(function() {
      if (el.parentNode) {
        el.classList.remove('tf-sp-visible');
        setTimeout(function() { if (el.parentNode) el.remove(); }, 300);
      }
    }, 5000);

    sessionStorage.setItem('tf_sp_count', String(count + 1));
  }

  // Show first notification after 15 seconds, then every 45-90 seconds
  if (!window.location.pathname.includes('/checkout')) {
    setTimeout(showSocialProof, 15000);
    setInterval(function() {
      setTimeout(showSocialProof, Math.random() * 45000);
    }, 60000);
  }


  // ============================================================
  // 2. STICKY MOBILE CTA BAR (Product Pages Only)
  // ============================================================
  if (document.body.classList.contains('template-product')) {
    var buyBtn = document.getElementById('buy-now-button');
    var priceEl = document.querySelector('.t4s-product-price, .t4s-pr-price');

    if (buyBtn || priceEl) {
      var stickyBar = document.createElement('div');
      stickyBar.id = 'tf-sticky-cta';

      var productTitle = document.querySelector('.t4s-product-title, .t4s-product__info-container h1');
      var titleText = productTitle ? productTitle.textContent.trim() : 'Title Search';
      if (titleText.length > 30) titleText = titleText.substring(0, 30) + '…';

      var priceText = priceEl ? priceEl.textContent.trim() : '';

      stickyBar.innerHTML = [
        '<div class="tf-sticky-inner">',
        '  <div class="tf-sticky-info">',
        '    <span class="tf-sticky-title">' + titleText + '</span>',
        '    <span class="tf-sticky-price">' + priceText + '</span>',
        '  </div>',
        '  <button class="tf-sticky-btn" id="tf-sticky-buy">Order Now</button>',
        '</div>'
      ].join('');

      document.body.appendChild(stickyBar);

      document.getElementById('tf-sticky-buy').onclick = function() {
        var addressInput = document.getElementById('product-address-input');
        if (addressInput) {
          addressInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
          addressInput.focus();
        } else if (buyBtn) {
          buyBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
          buyBtn.click();
        }
      };

      // Show/hide based on scroll position
      var lastScroll = 0;
      var buyBtnRect = null;

      function updateStickyVisibility() {
        var scrollY = window.scrollY;
        var shouldShow = scrollY > 400;

        // Hide if buy button is in viewport
        if (buyBtn) {
          buyBtnRect = buyBtn.getBoundingClientRect();
          if (buyBtnRect.top > 0 && buyBtnRect.top < window.innerHeight) {
            shouldShow = false;
          }
        }

        stickyBar.classList.toggle('tf-sticky-visible', shouldShow);
        lastScroll = scrollY;
      }

      window.addEventListener('scroll', updateStickyVisibility, { passive: true });
      updateStickyVisibility();
    }
  }


  // ============================================================
  // 3. LIVE ACTIVITY COUNTER (Homepage)
  // "X title searches today"
  // ============================================================
  var statsSection = document.querySelector('.tf-stats');
  if (statsSection && window.location.pathname === '/') {
    // Generate a realistic-looking daily count
    var now = new Date();
    var hour = now.getHours();
    var baseCount = 12 + Math.floor(hour * 2.3) + Math.floor(Math.random() * 5);

    var liveCounter = document.createElement('div');
    liveCounter.className = 'tf-live-activity';
    liveCounter.innerHTML = [
      '<div class="tf-live-dot"></div>',
      '<span><strong>' + baseCount + ' title searches</strong> completed today</span>'
    ].join('');

    // Insert after stats section
    statsSection.parentNode.insertBefore(liveCounter, statsSection.nextSibling);

    // Slowly increment
    setInterval(function() {
      baseCount += Math.random() > 0.7 ? 1 : 0;
      liveCounter.querySelector('strong').textContent = baseCount + ' title searches';
    }, 30000);
  }


  // ============================================================
  // 4. URGENCY BADGE ON PRODUCT PAGES
  // ============================================================
  if (document.body.classList.contains('template-product')) {
    var productInfo = document.querySelector('.t4s-product__info-container, .t4s-product-info');
    if (productInfo) {
      var urgencyEl = document.createElement('div');
      urgencyEl.className = 'tf-urgency';

      var viewers = 2 + Math.floor(Math.random() * 6);
      urgencyEl.innerHTML = [
        '<div class="tf-urgency-item">',
        '  <span class="tf-urgency-dot"></span>',
        '  <span>' + viewers + ' people viewing the same product right now</span>',
        '</div>',
        '<div class="tf-urgency-item tf-urgency-delivery">',
        '  <span>⚡</span>',
        '  <span>Order now — <strong>delivered to your email within minutes</strong></span>',
        '</div>'
      ].join('');

      // Insert before the buy button or after price
      var insertTarget = document.getElementById('buy-now-button') || productInfo.querySelector('.t4s-product-price');
      if (insertTarget) {
        insertTarget.parentNode.insertBefore(urgencyEl, insertTarget);
      }

      // Vary viewer count slightly
      setInterval(function() {
        viewers += Math.random() > 0.5 ? 1 : -1;
        viewers = Math.max(1, Math.min(9, viewers));
        urgencyEl.querySelector('.tf-urgency-item span:last-child').textContent = viewers + ' people viewing the same product right now';
      }, 20000);
    }
  }


  // ============================================================
  // STYLES
  // ============================================================
  var style = document.createElement('style');
  style.textContent = [
    '/* --- Social Proof Notification --- */',
    '.tf-social-proof {',
    '  position: fixed; bottom: 20px; left: 20px; z-index: 99998;',
    '  background: #fff; border-radius: 14px; padding: 14px 18px;',
    '  box-shadow: 0 8px 30px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.06);',
    '  display: flex; align-items: center; gap: 12px;',
    '  max-width: 340px; transform: translateX(-120%);',
    '  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);',
    '  border: 1px solid #e2e8f0; font-family: "Inter", system-ui, sans-serif;',
    '}',
    '.tf-social-proof.tf-sp-visible { transform: translateX(0); }',
    '.tf-sp-icon { font-size: 28px; flex-shrink: 0; }',
    '.tf-sp-text { display: flex; flex-direction: column; gap: 2px; }',
    '.tf-sp-text strong { font-size: 13px; color: #0a3d5c; font-weight: 700; }',
    '.tf-sp-text span { font-size: 12px; color: #64748b; font-weight: 400; }',
    '.tf-sp-close {',
    '  position: absolute; top: 6px; right: 8px;',
    '  background: none; border: none; font-size: 16px;',
    '  color: #94a3b8; cursor: pointer; padding: 2px;',
    '}',
    '.tf-sp-close:hover { color: #475569; }',
    '',
    '/* --- Sticky Mobile CTA --- */',
    '#tf-sticky-cta {',
    '  position: fixed; bottom: 0; left: 0; right: 0; z-index: 99997;',
    '  background: #fffffffa; backdrop-filter: blur(12px);',
    '  -webkit-backdrop-filter: blur(12px);',
    '  border-top: 1px solid #e2e8f0;',
    '  box-shadow: 0 -4px 20px rgba(0,0,0,0.08);',
    '  transform: translateY(100%); transition: transform 0.3s ease;',
    '  font-family: "Inter", system-ui, sans-serif;',
    '}',
    '#tf-sticky-cta.tf-sticky-visible { transform: translateY(0); }',
    '.tf-sticky-inner {',
    '  max-width: 600px; margin: 0 auto;',
    '  padding: 12px 16px; display: flex;',
    '  align-items: center; justify-content: space-between; gap: 12px;',
    '}',
    '.tf-sticky-info { display: flex; flex-direction: column; gap: 2px; }',
    '.tf-sticky-title { font-size: 13px; font-weight: 600; color: #0a3d5c; }',
    '.tf-sticky-price { font-size: 17px; font-weight: 800; color: #00BADB; }',
    '.tf-sticky-btn {',
    '  background: #00BADB; color: #fff; border: none;',
    '  padding: 12px 28px; border-radius: 10px;',
    '  font-size: 15px; font-weight: 700; cursor: pointer;',
    '  white-space: nowrap; box-shadow: 0 4px 14px rgba(0,186,219,0.35);',
    '  transition: all 0.2s; flex-shrink: 0;',
    '}',
    '.tf-sticky-btn:hover { background: #0a3d5c; }',
    '',
    '/* --- Live Activity Counter --- */',
    '.tf-live-activity {',
    '  display: flex; align-items: center; justify-content: center;',
    '  gap: 8px; padding: 10px 20px;',
    '  background: #f0fdf4; border-bottom: 1px solid #dcfce7;',
    '  font-family: "Inter", system-ui, sans-serif;',
    '  font-size: 13px; color: #166534; font-weight: 500;',
    '}',
    '.tf-live-dot {',
    '  width: 8px; height: 8px; background: #22c55e;',
    '  border-radius: 50%; flex-shrink: 0;',
    '  animation: tfPulse 2s infinite;',
    '}',
    '@keyframes tfPulse {',
    '  0%, 100% { opacity: 1; transform: scale(1); }',
    '  50% { opacity: 0.5; transform: scale(0.8); }',
    '}',
    '',
    '/* --- Urgency Badge --- */',
    '.tf-urgency {',
    '  margin: 16px 0; display: flex; flex-direction: column; gap: 8px;',
    '  font-family: "Inter", system-ui, sans-serif;',
    '}',
    '.tf-urgency-item {',
    '  display: flex; align-items: center; gap: 8px;',
    '  font-size: 13px; color: #475569; font-weight: 500;',
    '}',
    '.tf-urgency-dot {',
    '  width: 8px; height: 8px; background: #f59e0b;',
    '  border-radius: 50%; flex-shrink: 0;',
    '  animation: tfPulse 1.5s infinite;',
    '}',
    '.tf-urgency-delivery { color: #166534; }',
    '.tf-urgency-delivery strong { font-weight: 700; }',
    '',
    '/* Social proof mobile adjustment */',
    '@media (max-width: 768px) {',
    '  .tf-social-proof {',
    '    bottom: 80px; left: 10px; right: 10px;',
    '    max-width: none;',
    '  }',
    '  #tf-sticky-cta { padding-bottom: env(safe-area-inset-bottom, 0); }',
    '}',
    '',
    '/* Hide sticky bar on desktop if not needed */',
    '@media (min-width: 769px) {',
    '  #tf-sticky-cta { display: none; }',
    '}'
  ].join('\n');
  document.head.appendChild(style);

})();
